/**
 *
 * @module entry
 * @desc {SDK.Services.Paywall} entry point.
 *
 */

import AccountEntitlementContext from './accountEntitlementContext';
import Campaign from './campaign';
import IntroPrice from './introPrice';
import Paywall from './paywall';
import PaywallClient from './paywallClient';
import PaywallClientConfiguration from './paywallClientConfiguration';
import PaywallClientEndpoint from './paywallClientEndpoint';
import Product from './product';
import ProductType from './productType';
import TimeUnit from './timeUnit';

/**
 *
 * @typedef SDK.Services.Paywall
 * @type {Object}
 *
 * @property {AccountEntitlementContext} AccountEntitlementContext
 * @property {Campaign} Campaign
 * @property {IntroPrice} IntroPrice
 * @property {Paywall} Paywall
 * @property {PaywallClient} PaywallClient
 * @property {PaywallClientConfiguration} PaywallClientConfiguration
 * @property {PaywallClientEndpoint} PaywallClientEndpoint
 * @property {Product} Product
 * @property {ProductType} ProductType
 * @property {TimeUnit} TimeUnit
 *
 */

/**
 *
 * @type {SDK.Services.Paywall}
 *
 */
export default {

    AccountEntitlementContext,
    Campaign,
    IntroPrice,
    Paywall,
    PaywallClient,
    PaywallClientConfiguration,
    PaywallClientEndpoint,
    Product,
    ProductType,
    TimeUnit

};



// WEBPACK FOOTER //
// ./src/services/paywall/entry.js